<template>
  <div id="assign-to-class">
    <div class="base-create">
      <div  v-for="(item,index) in assigned_group" :key="item.id">
        <el-row class="mb-px-16 mt-px-16">
          <el-col :span="8">
            <div class="class-row">
              <p>
                <span class="label">{{item.group_name}}</span>
              </p>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="date-row">
              <p>
                <span class="label">{{$t("study_sets.assigned_on_date",{
                  date: formatDate(item.created_at)
                  })}}</span>
              </p>
            </div>
          </el-col>
        
        </el-row>
        <hr v-if="index < assigned_group.length - 1" />
        
      </div>
    </div>
  </div>
</template>

<script>
// import Chip from "@/components/common/Chip";
import { pathOr, isNil, compose, propOr, length } from 'ramda'
import { mapActions, mapGetters } from 'vuex'
import { memberships } from '@/helpers/memberships'
import { DefaultShareableOptions } from '@/constants/studySets'
import { getOptionsLabels } from '@/utils/elementUi'
import TertiaryButton from '@/components/common/buttons/TertiaryButton'
import { format } from 'date-fns'
import { DATE_FORMAT } from "@/constants/generic"

export default {
  components: {
   
  },
  props: {
    studysetDetails: {},
    organizationType: {},
    editClass: {
      type: Function,
      default: () => {}
    },
    showEditClass: {
      type: Boolean,
      default: true
    },
    showUserInfo: {
      type: Boolean,
      default: true
    },
    organizationId: {},
    uploadId: {
      default: null
    },
     dateFormat: {
      type: String,
      default: DATE_FORMAT
    }
  },
  data() {
    return {
      showStudentsModal: false,
      showImportModal: false,
      uploadDetails: {}
    }
  },
  computed: {
    startEndDate() {
      const not_selected = this.$t('classes.create_class_flow.class_overview.not_selected')
      const start_date = isNil(this.studysetDetails.startDate) ? not_selected : new Date(this.studysetDetails.startDate).toDateString()
      const end_date = isNil(this.studysetDetails.endDate) ? not_selected : new Date(this.studysetDetails.endDate).toDateString()

      return `${start_date} - ${end_date}`
    },
    classId() {
      return pathOr(null, ['studysetDetails', 'id'])(this)
    },
    ...mapGetters({
      isTeacher: 'organization/isOrganizationTeacher',
      isAdmin: 'organization/isOrganizationAdmin',
      isAssociateAdmin: 'organization/isOrganizationAssociateAdmin',
      currentUser: 'user/getUser'
    }),
    assigned_group() {
      return this.studysetDetails &&this.studysetDetails.assigned_group? this.studysetDetails.assigned_group: [];
    },
    isTeacherAndAdmin() {
      return this.isAdmin || !this.isTeacher
    },
    users() {
      // if (this.uploadId) {
      //   return compose(
      //     map(objOf("text")),
      //     pathOr([], ["uploadDetails", "emails"])
      //   )(this);
      // }
      return pathOr([], ['studysetDetails', 'users'])(this)
    },
    consent() {
      if (this.uploadId) {
        return pathOr([], ['uploadDetails', 'consent'])(this)
      }
      return pathOr([], ['studysetDetails', 'consent'])(this)
    },
    numberOfUsers: compose(length, propOr([], 'users'))
  },
  methods: {
    getShareableLabel(v) {
      return getOptionsLabels(DefaultShareableOptions, v)
    },
    getNameMembership(membership_id) {
      if (membership_id in memberships) {
        return memberships[membership_id]['full_name']
      }
      return ''
    },
        formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : '--'
    },
    ...mapActions('invite', ['postSentInviteUploadEmails', 'patchInviteUploadEmails', 'getInviteUploadEmails'])
  },
  watch: {
    // uploadId: {
    //   immediate: true,
    //   deep: true,
    //   async handler(newUploadId) {
    //     if (newUploadId) {
    //       const response = await this.getInviteUploadEmails({
    //         uploadId: this.uploadId
    //       });
    //       this.uploadDetails = propOr([], "data")(response);
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors.scss';
h3 {
  text-transform: none;
}
.class-teacher {
  margin-top: 40px;
  .user-info {
    display: flex;
    flex-direction: column;
    .name {
      color: $black;
    }
  }
}
p {
  font-weight: 300;
  font-size: 18px;
  color: $dark-blue-2;
  margin: 0;
}
.practice {
  display: flex;
  align-items: center;
  margin-top: 24px;
  .input-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: $black;
    .goal-value {
      font-weight: bold;
      font-size: 20px;
      color: #478dff;
      padding: 0 5px;
    }
  }
  .description {
    p {
      margin-top: 5px;
      font-size: 16px;
      line-height: 24px;
      opacity: 0.7;
    }
    .assessment-test-title {
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      color: $black;
      opacity: 1;
    }
  }
  .box-card {
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 16px;
    // margin-bottom: 24px;
    height: 214px;
    width: 100%;
    ::v-deep .el-card__body {
      align-items: flex-start;
      .card-number {
        margin-bottom: 8px;
      }
      .card-content {
        flex: 1 0;

        h2 {
          font-size: 24px;
          line-height: 36px;
          color: #121131;
        }

        p {
          font-size: 16px;
          line-height: 24px;
          color: #121131;
        }

        button {
          float: right;
        }
      }
    }
  }
}
.line-separate {
  border: 1px solid#E6E6E6;
  margin: 40px 0 32px;
}

#assign-to-class {
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 8px 64px;
  margin-bottom: 24px;
  min-height: 80px;
}

.class-row {
  padding:10px 0px;
  p {
    font-weight: 600;
    font-size: 16px;
    color: #121131;
    margin: 0;
    text-align: initial;
  }
}
.date-row {
  padding:10px 0px;
  p {
    font-weight: 400;
    font-size: 16px;
    color: #121131;
    margin: 0;
    text-align: right;
  }
}
.button-row {
  p {
    font-weight: 600;
    font-size: 16px;
    color: #121131;
    margin: 0;
    text-align: initial;
  }
}

#phrases-wrapper {
  background: #f1f1f1;
  border-radius: 8px;
  padding: 16px;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 8px #c2c2c2;
    border-radius: 100px;
  }
}

#phrases-list {
  overflow: auto;
  height: 250px;
  padding-left: 0px;
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  padding: 0;

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #edf4ff;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c2c2c2;
    // box-shadow: inset 0 0 8px #C2C2C2;
    border-radius: 100px;
  }
}

#phrases-list li {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  color: #121131;
  margin-bottom: 16px;
  display: flex;
}

.delete-button {
  height: 40px !important;
  width: 40px;
  min-width: 40px;
  color: $red !important;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
}

</style>
